export const START_REQUEST = 'START_REQUEST';
export const END_REQUEST = 'END_REQUEST';
export const ABORT_REQUEST = 'ABORT_REQUEST';
